<div class="user-preferences-button" [attr.disabled]="isDisabled ? '' : null" (click)="openUserPreferences()">
  <img src="{{ 'User-Preferences.svg' | xsImage }}">
</div>
